import styled from 'styled-components';

import { MixedCheckbox } from '@reach/checkbox';

import checkboxChecked from './checkbox-checked.svg';
import checkboxCheckedDisabled from './checkbox-checked-disabled.svg';
import checkboxMixed from './checkbox-mixed.svg';
import checkboxMixedDisabled from './checkbox-mixed-disabled.svg';

export const Input = styled(MixedCheckbox)`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
  appearance: none;
  margin: 0;
  background: white;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  border: thin solid var(--coolGray-300);
  border-radius: 4px;
  outline: none;

  &:disabled {
    background-color: var(--coolGray-300);
    border-color: var(--coolGray-300);

    &:checked {
      background-color: var(--coolGray-300);
      background-image: url(${checkboxCheckedDisabled});
      border-color: var(--coolGray-300);
    }

    &[aria-checked='mixed'] {
      background-color: var(--coolGray-300);
      background-image: url(${checkboxMixedDisabled});
      border-color: var(--coolGray-300);
    }
  }

  &:enabled {
    &:checked {
      background-color: var(--blue-700);
      background-image: url(${checkboxChecked});
      border-color: var(--blue-700);
      box-shadow: var(--shadow-base);
    }

    &[aria-checked='mixed'] {
      background-color: var(--blue-700);
      background-image: url(${checkboxMixed});
      border-color: var(--blue-700);
      box-shadow: var(--shadow-base);
    }

    &:hover,
    &:focus {
      border-color: var(--blue-400);
    }

    &:focus-visible {
      border-color: var(--blue-400);
      box-shadow: 0 0 0 2px var(--indigoOutlineColor);
    }
  }

  &[data-invalid='true'] {
    border-color: var(--pink-900);

    &:hover {
      border-color: var(--pink-900);
    }

    &:focus {
      border-color: var(--pink-900);
      box-shadow: 0 0 0 2px var(--pink-200);
    }
  }
`;
